import React from 'react';

import {
  Dialog,
  LegacyText,
  Button,
  LegacyBox,
  makeStyles,
} from '@gogame/components';
import { ScreenLink } from '@gogame/screens';

import { spendAdjustmentLink } from 'scenes/SpendAdjustments/navigation';

const percentFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
  style: 'percent',
});
const useStyles = makeStyles({
  content: {
    width: '600px',
  },
});
const LowerDialog = ({
  onClose,
  onSubmit,
  onExited,
  open,
  spendingSource,
  spendingGapAbsolute,
  spendingGapFactor,
}) => {
  const classes = useStyles();

  const operator = spendingGapAbsolute.amount > 0 ? 'higher' : 'lower';

  return (
    <Dialog
      disableEscapeKeyDown={true}
      fullScreen={false}
      onClose={onClose}
      open={open}
      onExited={onExited}
    >
      <Dialog.Title title={'Spend GAP Warning'} />
      <Dialog.Content className={classes.content}>
        <LegacyBox vertical={true} gutter={16}>
          <LegacyText>
            The invoices you are trying to upload is{' '}
            {percentFormatter.format(spendingGapFactor)} {operator} than spend
            in the tracker, would you like to update the spend?
          </LegacyText>

          {!spendingSource ? (
            <LegacyText type={'error'}>
              This is API spend - needs to contact support and repull API spend
              for specific period
            </LegacyText>
          ) : (
            <LegacyText>
              Please note, once it is approved you will not be able to make
              changes to the spend
            </LegacyText>
          )}
        </LegacyBox>
      </Dialog.Content>
      <Dialog.Actions>
        {spendingSource ? (
          <ScreenLink
            link={spendAdjustmentLink}
            target={'_blank'}
            underline={'none'}
          >
            <Button variant={'outlined'}>Open Spend Adjustments</Button>
          </ScreenLink>
        ) : null}
        <Button variant={'outlined'} onClick={onSubmit}>
          Save
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default LowerDialog;
